import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

const Tab = /*#__PURE__*/ React.forwardRef((_param, ref)=> {
    var { label , onClick , isActive , className , variant ='primary'  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "label",
        "onClick",
        "isActive",
        "className",
        "variant"
    ]);
    return React.createElement("button", swcHelpers.extends({}, rest, {
        onClick: onClick,
        className: classnames(`tab tab--${variant}`, className, {
            _is_active: isActive
        }),
        "aria-pressed": isActive
    }), label);
});
Tab.displayName = 'Tab';
var Tab$1 = Tab;

export { Tab$1 as default };
//# sourceMappingURL=Tab.js.map
